import React from 'react';
import PropTypes from 'prop-types';
import Card from 'common/card/Card';
import ThingsYouShouldKnow from 'spot-details/details/ThingsYouShouldKnow';

const ThingsToKnowCardPanel = ({facility, selectedRate, isMonthly}) => {
    return (
        <Card className="ThingsToKnowCardPanel" title="Things To Know">
            <ThingsYouShouldKnow
                facility={facility}
                rate={selectedRate}
                isMonthly={isMonthly}
                onShowRateDetailsClick={() => {}} // eslint-disable-line react/jsx-no-bind, no-empty-function
            />
        </Card>
    );
};

ThingsToKnowCardPanel.propTypes = {
    facility: PropTypes.object.isRequired,
    selectedRate: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
        .isRequired,
    isMonthly: PropTypes.bool,
};

export default ThingsToKnowCardPanel;
